import { isSameDay, startOfMonth } from 'date-fns';
import Decimal from 'decimal.js';
import { utils } from "../utils";
import { getLastXMonths } from "../utils/date.utils";
import pluralize from "../utils/pluralize";
import { fromDateStampObject } from "./time";
export let SalesSummaryStatus = /*#__PURE__*/function (SalesSummaryStatus) {
  SalesSummaryStatus["Sent"] = "sent";
  SalesSummaryStatus["Approved"] = "approved";
  SalesSummaryStatus["Terminated"] = "terminated";
  SalesSummaryStatus["Canceled"] = "canceled";
  SalesSummaryStatus["Reviewed"] = "reviewed";
  SalesSummaryStatus["Expired"] = "expired";
  return SalesSummaryStatus;
}({});
export class SalesSummaryModel {
  static fromDTO(dto, now) {
    const items = dto.calendar.map(SalesSummaryModel.itemFromDTO);
    return new SalesSummaryModel({
      numProposalsSentThisYear: new Decimal(dto.numProposalsSentThisYear),
      medianTimeToSign: new Decimal(dto.medianTimeToSign),
      calendar: fillLast12Months(items, now)
    });
  }
  static itemFromDTO(dto) {
    return {
      date: fromDateStampObject(dto.date),
      statuses: makeFullStatuses(dto.statuses)
    };
  }
  constructor(data) {
    this.data = data;
  }
  isEmpty() {
    return this.data.numProposalsSentThisYear.isZero();
  }
  formattedNumProposalsSentThisYear() {
    return utils.formatNumberWithCommas(this.data.numProposalsSentThisYear);
  }
  formattedMedianTimeToSign() {
    return this.isEmpty() ? 'Not available' : pluralize('Day', this.data.medianTimeToSign.toDP(1).toNumber(), true);
  }
  calendar() {
    return this.data.calendar;
  }
}
function fillLast12Months(data, now) {
  return getLastXMonths(now, 12).map(date => {
    const asFirstOfMonth = startOfMonth(date);
    return data.find(item => isSameDay(asFirstOfMonth, startOfMonth(item.date))) || {
      date,
      statuses: makeFullStatuses({})
    };
  });
}
function makeFullStatuses(statuses) {
  return {
    [SalesSummaryStatus.Sent]: makeStatusValue(statuses[SalesSummaryStatus.Sent]),
    [SalesSummaryStatus.Approved]: makeStatusValue(statuses[SalesSummaryStatus.Approved]),
    [SalesSummaryStatus.Terminated]: makeStatusValue(statuses[SalesSummaryStatus.Terminated]),
    [SalesSummaryStatus.Canceled]: makeStatusValue(statuses[SalesSummaryStatus.Canceled]),
    [SalesSummaryStatus.Reviewed]: makeStatusValue(statuses[SalesSummaryStatus.Reviewed]),
    [SalesSummaryStatus.Expired]: makeStatusValue(statuses[SalesSummaryStatus.Expired])
  };
}
function makeStatusValue(dto) {
  return {
    total: new Decimal(dto ? dto.total : 0)
  };
}